import React from 'react';
import styles from './Solutions.module.scss';
import { Link, useNavigate } from "react-router-dom";
const Solutions = () => {
    const navigate = useNavigate();
    const categories = [
        {
            title: "Services",
            items: ["SAP S/4 Hana Conversion", "SAP Application Support (SAP AMS)"],
        },
        {
            title: "SAP S/4Hana",
            items: ["RISE with SAP", "SAP S/4Hana Cloud"],
        },
        {
            title: "Industrial Solutions",
            items: ["SAP S/4HANA Retail", "SAP S/4HANA Fashion Vertical Business (FMS)"],
        },
        {
            title: "Omnichannel",
            items: ["SAP CAR", "SAP CAR POSDTA", "SAP CAR OAA", "SAP CAR OPP"],
        },
        {
            title: "SAP Forecast and Planning",
            items: ["SAP Forecast and Replenishment (F&R)", "Unified Demand Forecast (UDF)", "SAP Demand Data Foundation (DDF)", "Fiori"],
        },
        {
            title: "SAP Logistics Solutions",
            items: [
                "SAP Customer Service (SAP CS)",
                "SAP Sales and Distribution (SAP SD)",
                "SAP Material Management (SAP MM)",
                "SAP Advanced Available-to-Promise (aATP)"],

        },
        {
            title: "Technical Solutions",
            items: [
                "SAP Customer Service (SAP CS)",
                "SAP Sales and Distribution (SAP SD)",
                "SAP Material Management (SAP MM)",
                "SAP Advanced Available-to-Promise (aATP)"],

        }
    ];
    const handleNavigation = (route) => {
        navigate(route); // Navigate to the specified route
      };
    return (
        <div className={styles.container}>
            {categories.map((category, index) => (
                <div key={index} className={styles.category}>
                    <h3 className={styles.title}>{category.title}</h3>
                    <div className={styles.items}>
                        {category.items.map((item, idx) => (
                            <span key={idx} className={styles.item} onClick={()=>handleNavigation(item.replaceAll('/','-'))}>
                                {item}
                            </span>
                        ))}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default Solutions;
